// Terrarium-encoded DEM used for 3D terrain exaggeration across all basemaps
// (main 3D map and hunt planner 3D). Virtual-hosted S3 URL serves over HTTP/2;
// MapLibre's 'terrarium' encoding matches the (R*256 + G + B/256) - 32768 formula
// used by the elevation-tiles-prod dataset.
//
// Do not substitute MapTiler terrain-rgb-v2 (or maptilersdk's enableTerrain(),
// which hardwires it): its coarse ~30 m global source draws false relief, e.g. a
// ~22 m hill where USGS 3DEP and Terrarium agree on a hollow (-85.104, 39.547).
export const TERRARIUM_DEM_SOURCE = {
  type: 'raster-dem',
  tiles: ['https://elevation-tiles-prod.s3.amazonaws.com/terrarium/{z}/{x}/{y}.png'],
  tileSize: 256,
  encoding: 'terrarium',
  maxzoom: 15,
}
